import { createFileRoute } from "@tanstack/react-router";
import AdminLogin from "@/pages/admin/Login";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/login")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-login", path: "/admin/login", title: "Cloud Admin Login", description: "Admininloggning" },
      [],
      { noindex: true },
    ),
  component: AdminLogin,
});
